"use client";

import { use } from "react";
import { PostDetail } from "../../_modules/components/PostDetail";

export default function ForumPostPage({ params }: { params: Promise<{ slug: string }> }) {
  const { slug } = use(params);
  return <PostDetail idOrSlug={slug} />;
}
